if (document.getElementById("calendar")) {
  const calMonthLinks = document.querySelectorAll(".calendar--month");
  const calMonthLinkActive = document.querySelector(".calendar--month.active");
  const calItems = document.querySelectorAll(".calendar--item");

  calItems.forEach(c => {
    let dateAttr = c.dataset.date.split("/");
    dateAttr = dateAttr[1] + "-" + dateAttr[2];
    if (dateAttr === calMonthLinkActive.dataset.month) {
      c.classList.remove("hidden");
      c.classList.remove("off");
    } else {
      c.classList.add("hidden");
      c.classList.add("off");
    }

    calMonthLinks.forEach(m => {
      let target = m.dataset.month;
      target === dateAttr ? m.classList.add("hasEntry") : "";
    });
  });

  calMonthLinks.forEach(m => {
    m.addEventListener("click", e => {
      e.preventDefault();
      calMonthLinks.forEach(i => i.classList.remove("active"));
      m.classList.add("active");

      const target = m.dataset.month;
      console.log(target);
      calItems.forEach(cal => {
        let dateAttr = cal.dataset.date.split("/");
        dateAttr = dateAttr[1] + "-" + dateAttr[2];
        if (target === dateAttr) {
          cal.classList.remove("off");
          setTimeout(() => cal.classList.remove("hidden"), 300);
        } else {
          cal.classList.add("hidden");
          setTimeout(() => cal.classList.add("off"), 300);
        }
      });
    });
  });
}
const findDates = (date, el) => {

  const matchingDates = document.querySelectorAll(`[data-filter="${date}"]`)
  const filterElements = document.querySelectorAll('.kalender--date-filter')
  const dateEntries = document.querySelectorAll(`.kalender--item`)

  filterElements.forEach(a => a.classList.remove('active'))
  el.classList.add('active')
  dateEntries.forEach(entry => entry.style.display = "none")
  matchingDates.forEach(m => m.style.display = "")
}